/** 표 안 인라인 입력(이름·시간 등)이 누를 수 있는 필드처럼 보이도록 하는 공용 sx.
 *  fontSize·height 등은 사용처에서 `{ ...inlineFieldSx, fontSize: 12 }` 로 덧붙인다. */
export const inlineFieldSx = {
  px: 1,
  border: '1px solid #cbd5e1',
  borderRadius: 1.5,
  backgroundColor: '#fff',
  '&:hover': { borderColor: '#94a3b8' },
  '&.Mui-focused': { borderColor: '#2563eb', boxShadow: '0 0 0 2px rgba(37,99,235,0.15)' },
};
